module.exports = __webpack_public_path__ + "static/surya-digital-logo-f2b7649b8cafd314faf4f3ba06774c65.png";